export default __webpack_public_path__ + "static/media/walks.ba6fbcb4.svg";